import { Outlet } from "react-router";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { PlatformTestConsole } from "@/features/platform-test-console/platform-test-console";
import { AppSidebar } from "./app-sidebar";
import { Header } from "./header";

export function AppShell() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <Header />
        <main className="flex min-h-0 flex-1 flex-col overflow-y-auto p-6">
          <Outlet />
        </main>
        <PlatformTestConsole />
      </SidebarInset>
    </SidebarProvider>
  );
}
